<template>
  <div class="a-vs-c--betting-history b-h a-vs-wrapper" @click="stopPropagation">
    <!-- Inner wrapper for header and main part -->
    <div class="a-vs-wrapper--inner-main-wrapper">
      <!-- MAIN -->
      <main class="history-background-color">
        <!-- Betting history header with filter -->
        <div class="a-vs-c-heading">
            <history-header class="title"
              :title="$t('betting_history')"
              :imageName="'close'"
              :imageClass="'a-vs-icon'"
              @onCloseHistory="onCloseHistory()"/>

            <div class="a-vs-c-filter">
              <status-picker
                ref="statusPicker"
                class="status-filter"
                :headerClass="'a-vs-c-single-filter'"
                :bodyClass="'a-vs-c-filter-content'"
                :title="$t('status')"
                :items = "statusList"
                v-model="selectedStatus" />

              <date-picker
                ref="periodFrom"
                class="a-vs-c-single-filter first-picker"
                :disabledDates="disabledDatesFrom"
                :title="$t('period_from')"
                v-model="datePickerFrom" />

              <date-picker
                ref="periodTo"
                class="a-vs-c-single-filter outofrange"
                :disabledDates="disabledDatesTo"
                :title="$t('period_to')"
                v-model="datePickerTo" />
            </div>
          </div>
          <!-- Main part with sorted tickets -->
        <played-tickets-history
          :selected="selectedStatus"
          :tickets="tickets"/>
      </main>
    </div>
  </div>
</template>
<script>
import api from '@/services/soccer/api.service.network.js'
import { eventBus } from '@/main.js'
import PlayedTicketsHistory from '@/components/soccer/ticket/PlayedTicketsHistory.vue'
import DatePicker from '@/components/common/DatePicker.vue'
import StatusPicker from '@/components/common/StatusPicker.vue'
import HistoryHeader from '@/components/common/HistoryHeader.vue'
import EventConstants from '@/constants/Events'

import vuexStore from '../../../store/vuexStore'

import generalMenuSound from '../../../assets/audio/general_menu.mp3'

export default {
  components: {
    'played-tickets-history': PlayedTicketsHistory,
    'date-picker': DatePicker,
    'status-picker': StatusPicker,
    'history-header': HistoryHeader
  },
  data () {
    return {
      tickets: [],
      selectedStatus: '3',
      datePickerFrom: new Date(),
      disabledDatesFrom: {
        to: new Date(2019, 1, 1),
        from: new Date()
      },
      datePickerTo: new Date(),
      disabledDatesTo: {
        to: new Date(),
        from: new Date()
      },
      hasAudioEnabled: vuexStore.state.hasAudioEnabled
    }
  },
  props: {
    visible: {
      type: Boolean,
      required: true
    }
  },
  methods: {
    onCloseHistory () {
      if (this.hasAudioEnabled) {
        var audio = new Audio(generalMenuSound)
        audio.play()
      }
      eventBus.showBettingHistory(false)
    },
    stopPropagation () {
      // haide container
      this.$refs.periodTo.hideCalendar()
      this.$refs.periodFrom.hideCalendar()
      this.$refs.statusPicker.hidePicker()
    },
    refreshBetHistory () {
      api.getBetHistoryTickets(this.datePickerFrom, this.datePickerTo)
        .subscribe(data => {
          this.tickets = data
        }, eventBus.onApiError)
    }
  },
  created: function () {
    eventBus.$on(EventConstants.VSOCCER_BETTING_HISTORY_REFRESH, this.refreshBetHistory)
  },
  beforeDestroy () {
    eventBus.$off(EventConstants.VSOCCER_BETTING_HISTORY_REFRESH, this.refreshBetHistory)
  },
  mounted () {
    let disabledDateToValue = new Date()
    disabledDateToValue.setDate(disabledDateToValue.getDate() - 3)
    this.disabledDatesFrom.to = disabledDateToValue
    this.$watch(
      () => vuexStore.state.hasAudioEnabled,
      () => {
        this.hasAudioEnabled = vuexStore.state.hasAudioEnabled
      }
    )
  },
  watch: {
    datePickerFrom: function (val) {
      this.disabledDatesTo.to = val
      this.refreshBetHistory()
    },
    selectedStatus: function (val) {
      this.refreshBetHistory()
    },
    datePickerTo: function (val) {
      this.disabledDatesFrom.from = val
      var tomorrow = new Date()
      tomorrow.setDate(new Date().getDate() + 1)
      this.disabledDatesTo.from = tomorrow
      this.refreshBetHistory()
    },
    visible: function (visible) {
      if (visible) {
        this.refreshBetHistory()
      }
    }
  },
  computed: {
    statusList () {
      return [
        { 'index': 3, 'title': this.$t('all') },
        { 'index': 1, 'title': this.$t('winning') },
        { 'index': 0, 'title': this.$t('losing') }
      ]
    }
  }
}
</script>

<style scoped>

</style>
